<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card :title="cardTitle" write-toggler @writeClick="popupOpen('', '')">
            <div class="vx-row">
                <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button>
                    <span class="ml-5 mr-5"
                        >{{ start_date.substring(0, 4) + '-' + start_date.substring(4, 6) + '-' + start_date.substring(6, 8) }} ~
                        {{ end_date.substring(0, 4) + '-' + end_date.substring(4, 6) + '-' + end_date.substring(6, 8) }}</span
                    >
                  <date-picker
                      id="datepicker-component"
                      v-model="now_date"
                      @change="updateDate"
                      type="week"
                      :lang="{formatLocale: {firstDayOfWeek: 1}}"
                      value-type="format"
                      format="YYYYMMDD"
                  >
                  </date-picker>
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>

                    <!-- 날짜 범위 필터 버튼 비활성화 (항상 7일) -->
                    <!-- <DayFilterButtons
                        :value="dayFilter"
                        @change="changeDayFilter"
                    /> -->
                </div>
            </div>
            <vs-button type="line" v-bind:class="activeMenu('')" v-on:click="tabClick('')" v-show="tab_all_tf">전체</vs-button>
            <vs-button type="line" v-for="(item, index) in tab_menu" :key="index" v-bind:class="activeMenu(item.MEDICAL_CD)" v-on:click="tabClick(item.MEDICAL_CD)">{{ item.MEDICAL_NM }}</vs-button>
            <br /><br />
            <div>
                <span>* 해당 날짜에 시간 셀을 클릭하시면 환자를 등록할 수 있습니다.</span>
            </div>
            <!-- <div class="text-right">
                <a :href="'/api/cure/excel/' + now_date + '?medical_cd=' + medical_cd" download="download"><vs-button size="small">엑셀다운로드</vs-button></a>
            </div> -->

            <div class="flex justify-end flex-wrap mb-3">
                <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="popupOpen('', '')" />

                <!-- 필터 검색 버튼 -->
                <vx-tooltip text="필터 검색" position="top" class="ml-3">
                    <vs-button
                        radius
                        color="success"
                        icon-pack="feather"
                        icon="icon-filter"
                        @click="openFilterModal"
                    />
                </vx-tooltip>

                <!-- Excel Download: Async version for better UX (2025-12-29) -->
                <vx-tooltip text="엑셀 다운로드" position="top" class="ml-3">
                    <vs-button
                        radius
                        color="primary"
                        icon-pack="feather"
                        icon="icon-download"
                        @click="requestExcelGeneration"
                        :disabled="excelGenerating"
                    />
                </vx-tooltip>

                <!-- 체크박스 다중 복사 모드 토글 -->
                <vx-tooltip text="체크박스 다중복사 모드" position="top" class="ml-3">
                    <vs-button
                        radius
                        :color="bulkCopyMode ? 'success' : 'warning'"
                        icon-pack="feather"
                        icon="icon-check-square"
                        @click="toggleBulkCopyMode"
                    />
                </vx-tooltip>

                <!-- 체크박스 다중 복사 실행 버튼 (모드가 활성화되고 선택된 항목이 있을 때만 표시) -->
                <vx-tooltip text="선택된 시간대로 복사 실행" position="top" class="ml-3" v-if="bulkCopyMode && selectedTimeSlots.size > 0 && selectedSchedules.length > 0">
                    <vs-button
                        radius
                        color="danger"
                        icon-pack="feather"
                        icon="icon-copy"
                        @click="executeBulkCopy"
                    />
                </vx-tooltip>
            </div>

            <!-- 필터 활성화 배너 -->
            <div v-if="filterModeActive" class="filter-active-banner mb-3">
                <div class="flex justify-between items-center">
                    <div class="flex items-center">
                        <i class="feather icon-filter mr-2"></i>
                        <span class="filter-info">
                            필터 활성: {{ filterCriteria.date.substring(0,4) }}-{{ filterCriteria.date.substring(4,6) }}-{{ filterCriteria.date.substring(6,8) }}
                            {{ filterCriteria.hour }}:00 - {{ filterCriteria.hour }}:59
                            <template v-if="filterCriteria.medicalCd">
                                ({{ getMedicalNameByCd(filterCriteria.medicalCd) }})
                            </template>
                            <template v-else>
                                (전체 치료실)
                            </template>
                        </span>
                    </div>
                    <vs-button size="small" color="warning" type="border" @click="resetFilter">
                        필터 해제
                    </vs-button>
                </div>
            </div>

            <!-- 캘린더 모드 (기본) -->
            <div class="tb_wrap" v-if="!filterMode">
                <div class="tb_box" id="calendarDiv" style="width:100%;overflow-x:auto;height:900px;">
                    <table id="schedule" class="border-collapse calendar" style="max-width:1200px; max-height:550px;">
                        <thead>
                            <tr class="fixed_top">
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="width:100px !important;">시간 / 일</th>
                                <th
                                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                    :style="item.substring(6, 8) == now_day ? 'background-color:#439798 !important; color:#fff;z-index:999;' : 'z-index:999;'"
                                    v-for="(item, index) in date_list"
                                    :key="index"
                                    v-bind:id="item"
                                >
                                    
                                    <div style="padding-bottom:5px;">
                                        <b style="font-size:12px;">{{ dayReturn(item) }}</b>
                                    </div>
                                    <div>
                                        <span v-for="(item2, index2) in JSON.parse(cure_count[index].JSON_DATA)" :key="index2" style="margin-top:10px;">
                                            <template v-if="JSON.parse(cure_count[index].JSON_DATA)[index2 + 1] == undefined"> {{ item2.MEDICAL_NM ? item2.MEDICAL_NM : '' }}({{ item2.CNT }}) </template>
                                            <template v-else> {{ item2.MEDICAL_NM ? item2.MEDICAL_NM : '' }}({{ item2.CNT }}) / </template>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                            <!-- 연차 행 (2026-02-23) -->
                            <VacationRow
                                :date-list="date_list"
                                :vacation-map="vacationMap"
                                :date-key-format="formatDateKeyForVacation"
                                :sticky="true"
                                sticky-top="70px"
                                :show-full-name="true"
                            />
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in cure_data" :key="index">
                                <!-- <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" style="" :id="item.CODE_TIME.substring(0, 2)"> -->
                                <th class="border border-solid d-theme-border-grey-light text-center table_header b-table-sticky-column timeHeader" style="" :id="item.code_time.substring(0, 2)">
                                    <span> {{ item.code_time.substring(0, 2) }}</span>
                                </th>
                                <td
                                    class="border border-solid d-theme-border-grey-light"
                                    style="min-width:700px;height:100px;vertical-align:top;padding:0px;"
                                    v-for="(ymd, schedule_index) in date_list"
                                    :key="schedule_index"
                                >
                                    <table class="contentTable" width="100%" cellspacing="0">
                                        <colgroup>
                                            <col width="50" />
                                            <col width="80" />
                                            <col width="20" />
                                            <col width="100" />
                                            <col width="200" />
                                            <col width="*" />
                                            <col width="100" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th class="text-center headerBtn" colspan="7">
                                                    <vs-row vs-type="flex" vs-justify="center">
                                                        <!-- 체크박스 다중 복사 모드일 때는 시간과 체크박스 표시 -->
                                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" v-if="bulkCopyMode">
                                                            <div class="flex items-center">
                                                                <span class="font-semibold mr-2">{{ item.code_time.substring(0,2) }}:{{ item.code_time.substring(2,4) }}</span>
                                                                <input 
                                                                    type="checkbox"
                                                                    :value="`${ymd}|${item.code_time}`"
                                                                    v-model="selectedTimeSlotsList"
                                                                    @change="updateSelectedTimeSlots"
                                                                    class="time-slot-checkbox"
                                                                    :title="`${dayReturn(ymd)} ${item.code_time.substring(0,2)}:${item.code_time.substring(2,4)} 시간대 선택`"
                                                                />
                                                            </div>
                                                        </vs-col>
                                                        
                                                        <!-- 기존 버튼들 (일반 모드일 때만 표시) -->
                                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" v-else>
                                                            <a href="javascript:void(0)" @click="popupOpen(ymd, item.code_time)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                                            </a>
                                                            <a href="javascript:void(0)" @click="clipCopyConfirm(ymd, item.code_time)">
                                                                <i class="vs-icon notranslate icon-scale feather icon-copy null" style="order: 0; margin-right: 0px; margin-left: 0px;"></i>
                                                            </a>
                                                            <!-- <a href="javascript:void(0)" @click="openMultiCopyModal(ymd, item.code_time)" title="다중복사">
                                                                <i class="vs-icon notranslate icon-scale feather icon-layers null" style="order: 0; margin-right: 0px; margin-left: 0px; color: #28a745;"></i>
                                                            </a> -->
                                                        </vs-col>
                                                    </vs-row>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item_data, item_index) in item.schedules_by_day[ymd]" :key="item_index" :style="getScheduleRowStyle(item_data)">
                                                <td>
                                                    <!-- 기존 복사용 체크박스 (일반 모드) -->
                                                    <input v-if="!bulkCopyMode" type="checkbox" v-model="copyChecked" :value="item_data.SCHEDULE_SEQ" />
                                                    
                                                    <!-- 새로운 체크박스 다중 복사용 체크박스 (체크박스 모드) -->
                                                    <input v-if="bulkCopyMode" type="checkbox" v-model="selectedSchedules" :value="item_data.SCHEDULE_SEQ" />
                                                </td>
                                                <td>{{ item_data.REAL_TIME_STRING.substring(0, 2) }}:{{ item_data.REAL_TIME_STRING.substring(2, 4) }}</td>
                                                <!-- 치료종류 : item_data.MEDICAL_NM.substring(0, 1) -->
                                                <td>[{{ item_data.MEDICAL_NM ? item_data.MEDICAL_NM.substring(0, 1) : '' }}]</td>
                                                <td>
                                                    <a :href="'/patientSchedule/scheduleCalendar/' + item_data.PATIENT_UID">
                                                        <!-- 치료자 : item_data.MEDICAL_ROOM_NUMBER_NM // item_data.PATIENT_USERNAME  -->
                                                        <template v-if="item_data.DC == 'Y'">
                                                            <span style="text-decoration:line-through"> {{ (!item_data.STATUS_NAME || item_data.STATUS_NAME === '외래') ? '외래' : item_data.MEDICAL_ROOM_NUMBER_NM }} {{ item_data.PATIENT_USERNAME }}</span>
                                                        </template>
                                                        <template v-else>{{ (!item_data.STATUS_NAME || item_data.STATUS_NAME === '외래') ? '외래' : item_data.MEDICAL_ROOM_NUMBER_NM }} {{ item_data.PATIENT_USERNAME }}</template>
                                                    </a>
                                                </td>
                                                <td>
                                                    <template v-if="item_data.DC == 'Y'">
                                                        <span>{{ item_data.DC_MEMO }}</span>
                                                    </template>
                                                    <template v-else>
                                                        <span>{{ item_data.managerNmList }}</span>
                                                        / {{ item_data.detailNmList }} / {{ item_data.MEMO }}
                                                    </template>
                                                </td>
                                                <td>{{ item_data.MEDICAL_MEMBER_USERNAME.substring(0, 1) }} / {{ item_data.WEST_MEDICAL_USERNAME.substring(0, 1) }}</td>
                                                <td>
                                                    <a href="#" @click="memberView(item_data.PATIENT_UID)">
                                                        <i class="vs-icon notranslate icon-scale  feather icon-search null" style="order: 0; margin-right: 0px; margin-left: 0px; color:#31C872;"></i>
                                                    </a>
                                                    &nbsp;
                                                    <a href="#" @click="popupmodify(item_data)">
                                                        <i class="vs-icon notranslate icon-scale feather icon-edit-2 null" style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"></i>
                                                    </a>
                                                    &nbsp;
                                                    <a href="javascript:void(0)" @click="calendarTdDelete(item_data)">
                                                        <i class="vs-icon notranslate icon-scale  feather icon-x null" style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Infinite scroll sentinel -->
                    <div
                        v-if="hasMoreTimeSlots"
                        ref="scrollSentinel"
                        style="height:40px; display:flex; justify-content:center; align-items:center;"
                    >
                        <span v-if="isLoadingMore">로딩 중...</span>
                    </div>
                </div>
            </div>

            <!-- 필터 모드 (필터 결과) -->
            <div v-else>
                <FilteredScheduleList
                    :schedules="filteredSchedules"
                    :filterCriteria="filterCriteria"
                    :treatmentRooms="tab_menu"
                    @member-view="memberView"
                    @schedule-edit="popupmodify"
                    @schedule-delete="calendarTdDelete"
                />
            </div>
        </vx-card>

        <!-- 필터 검색 모달 -->
        <ScheduleFilterModal
            :active.sync="filterModalVisible"
            :treatmentRooms="tab_menu"
            :dateList="date_list"
            :currentData="cure_data"
            @confirm="handleFilterConfirm"
            @cancel="closeFilterModal"
        />
        <vs-popup title="스케줄 등록 및 수정" :active.sync="popupActive">
            <form @submit.prevent>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <v-select :maxHeight="'50px'" @input="select_medical_input" v-model="select_medical_cd" :options="tab_options" :dir="$vs.rtl ? 'rtl' : 'ltr'"> </v-select>
                        <!--
                        <v-select :maxHeight="'50px'" v-model="select_medical_cd" :options="tab_options" :dir="$vs.rtl ? 'rtl' : 'ltr'"> </v-select> -->
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 ">
                        <label for="" class="vs-select--label">날짜</label>
                        <datepicker name="uniquename" v-model="select_date" placeholder="날짜선택" :format="customFormatter"></datepicker>
                    </div>
                    <div class="vx-col w-full lg:w-1/2">
                        <!-- <vs-select class="w-auto" v-model="select_time" autocomplete label="시간" placeholder="시간">
                            <vs-select-item v-for="(item, index) in time_list" :key="`time-${index}`" :value="item.CODE_TIME" :text="item.TIME_NAME" />
                        </vs-select> -->
                        <label for="" class="vs-select--label">시간(hhmm)-ex.0930</label>
                        <input
                            type="text"
                            class="w-full vs-inputx vs-input--input normal hasValue"
                            id="select_time"
                            name="select_time"
                            label="시간을 입력해주세요."
                            placeholder="시간을 입력해주세요."
                            maxlength="4"
                            v-model="select_time"
                        />
                    </div>
                </div>

                <vs-divider color="danger">DC</vs-divider>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/2 justify-between">
                        <span>
                            <vs-checkbox v-model="dc" style="width: 30%;">
                                DC
                            </vs-checkbox>
                        </span>
                    </div>
                    <div class="vx-col w-full lg:w-1/2 justify-between">
                        <span>
                            <vs-checkbox v-model="awaitTimeChk" @change="setAwaitTime" style="width: 30%;">
                                대기
                            </vs-checkbox>
                        </span>
                    </div>
                    <div class="vx-col w-full lg:w-1/1 justify-between">
                        <template v-if="dc == true">
                            <vs-input v-model="dc_memo" placeholder="취소사유" class="mt-1 w-full" />
                        </template>
                        <template >
                            <vs-input v-model="awaitTime" placeholder="시간" class="mt-1 w-full" v-show="this.userUid == '04059'"/>
                        </template>
                    </div>
                </div>
                <template v-if="viewManagerList.length > 0">
                    <vs-divider color="danger">치료자</vs-divider>
                    <div class="vx-row mb-3">
                        <div class="vx-col lg:w-1/1 justify-between" v-for="(item, index) in viewManagerList" :key="index">
                            <input type="radio" class="mr-2" :id="item.MEDICAL_MANAGER_NM" v-model="medicalManagers" :value="item.MEDICAL_MANAGER_CD" />
                            <label :for="item.MEDICAL_MANAGER_NM">
                                {{ item.MEDICAL_MANAGER_NM }}
                            </label>
                        </div>
                    </div>
                </template>
                <template v-if="viewDetailList.length > 0">
                    <vs-divider color="danger">스케줄</vs-divider>
                    <div class="vx-row mb-3">
                        <div class="vx-col lg:w-1/1 justify-between" v-for="(item, index) in viewDetailList" :key="index">
                            <input type="checkbox" class="mr-2" :id="item.MEDICAL_DETAIL_NM" v-model="medicalDetails" :value="item.MEDICAL_DETAIL_CD" />
                            <label :for="item.MEDICAL_DETAIL_NM">{{ item.MEDICAL_DETAIL_NM }}</label>
                        </div>
                    </div>
                </template>

                <vs-divider color="danger">환자</vs-divider>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <span style="font-size: 12px; color: red;">{{ select_user && select_user.inLongTerm === 'Y' ? '장기미내원환자' : '' }}</span>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/1">
                    <v-select
                        :maxHeight="'50px'"
                        ref="searchInput"
                        v-model="select_user"
                        :closeOnSelect="true"
                        :options="options"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        @open="resetOption()"
                        @search="onPatientSearch"
                        :filterable="false"
                        placeholder="환자 이름, 전화번호, 차트번호로 검색..."
                    />
                    <!-- <vs-input class="w-1/1" icon="search" placeholder="환자 이름 or 전화번호 or 차트번호 입력 후 엔터(Enter)" v-model="search" @keyup.enter="searchPatient()" /> -->
                </div>

                <vs-divider color="danger">메모</vs-divider>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/1">
                        <textarea id="memo" class="vs-component vs-con-textarea vs-textarea-primary" style="border: 1px solid rgba(0, 0, 0, 0.08);padding:20px;"></textarea>
                    </div>
                </div>

                <div class="vx-row" style="margin-top:300px;">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="calendarSave">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="popupClose">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>

        <vs-popup title="챠트보기" :active.sync="popupActive2">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <vx-card class="p-2">
                        <div class="text-center">
                            <p class="text-grey">#{{ chart_no }}</p>
                            <h4>{{ patientUsername }}({{ status_name }})</h4>
                            <p class="text-grey">{{ patientAge }}, {{ patientGender }}</p>
                            <p class="text-grey">{{ patient_phone }}</p>
                        </div>
                        <vs-divider></vs-divider>
                        <!-- <vs-avatar class="mx-auto my-6 block" size="80px" /> -->
                        <div class="flex justify-between text-center">
                            <span>
                                <p class="font-semibold">{{ medicalRoomNm }}({{ medicalRoomNumberNm }})</p>
                                <small class="text-grey">병동(호실)</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ medicalName }}</p>
                                <small class="text-grey">본 병원</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ sickNess }}</p>
                                <small class="text-grey">병명</small>
                            </span>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="my-6">
                            <h5 class="mb-2">치료플랜</h5>
                            <p class="plan_text">
                                <template v-if="plan == null || plan == 0">작성한 치료플랜 없음</template>
                                <template v-else>{{ plan }}</template>
                            </p>
                        </div>
                        <vs-divider></vs-divider>
                        <table style="width:100%;" class="border-collapse calendar">
                            <colgroup>
                                <col width="40%" />
                                <col width="60%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">최초입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_init_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">퇴원예정일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ out_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">왼퇴여부</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ complate_yn }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">식이</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ meal_name }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">보호자</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ protector_phone }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">주치의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ medical_nm }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">협진의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ west_medical_nm }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- <div class="my-6">
                            <h5 class="mb-2">컴플레인</h5>
                            {{ memo }}
                        </div> -->

                        <!-- <vs-button type="gradient" class="w-full mt-6" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="patientMemoSave">저장</vs-button> -->
                    </vx-card>
                </div>
            </div>
        </vs-popup>

        <!-- 다중 복사 팝업 -->
        <vs-popup title="다중 복사" :active.sync="multiCopyPopup" class="multi-copy-popup">
            <div class="multi-copy-container">
                <div class="mb-4">
                    <h5>복사할 스케줄 선택</h5>
                    <div v-for="(item_data, index) in getSelectedSchedulesForMultiCopy()" :key="index" class="schedule-item mb-2 p-2 border rounded">
                        <input type="checkbox" v-model="multiCopyChecked" :value="item_data.SCHEDULE_SEQ" class="mr-2" />
                        <span>{{ item_data.REAL_TIME_STRING.substring(0, 2) }}:{{ item_data.REAL_TIME_STRING.substring(2, 4) }}</span>
                        <span class="ml-2">[{{ item_data.MEDICAL_NM ? item_data.MEDICAL_NM.substring(0, 1) : '' }}]</span>
                        <span class="ml-2">{{ item_data.MEDICAL_ROOM_NUMBER_NM }} {{ item_data.PATIENT_USERNAME }}</span>
                    </div>
                </div>
                
                <div class="mb-4">
                    <h5>복사할 날짜/시간 설정</h5>
                    <div class="target-dates-container">
                        <div v-for="(target, index) in targetDates" :key="index" class="target-date-item mb-2 p-2 border rounded">
                            <div class="flex items-center justify-between">
                                <div class="flex items-center">
                                    <datepicker 
                                        v-model="target.date" 
                                        :format="customFormatter"
                                        placeholder="날짜 선택"
                                        class="mr-2"
                                    />
                                    <input 
                                        type="text" 
                                        v-model="target.time" 
                                        placeholder="시간(HHMM)" 
                                        maxlength="4"
                                        class="vs-inputx vs-input--input time-input"
                                    />
                                </div>
                                <vs-button type="border" color="danger" size="small" @click="removeTargetDate(index)">삭제</vs-button>
                            </div>
                        </div>
                        <vs-button type="border" color="primary" size="small" @click="addTargetDate">날짜 추가</vs-button>
                    </div>
                </div>

                <div class="flex justify-end mt-4">
                    <vs-button class="mr-2" @click="executeMultiCopy">다중 복사</vs-button>
                    <vs-button color="warning" type="border" @click="closeMultiCopyModal">취소</vs-button>
                </div>
            </div>
        </vs-popup>

        <!-- Excel Generation Progress Dialog (2025-12-29) -->
        <vs-popup title="엑셀 파일 생성" :active.sync="showExcelProgress">
            <div class="excel-progress-container p-4">
                <vs-progress
                    :percent="excelProgress"
                    :indeterminate="excelProgress === 0 || excelProgress === 20"
                    color="primary"
                    height="8"
                >
                    {{ excelStatusText }}
                </vs-progress>

                <p class="text-center mt-4">{{ excelStatusMessage }}</p>

                <div class="flex justify-center mt-6" v-if="excelProgress < 100">
                    <vs-button
                        color="danger"
                        type="border"
                        @click="cancelExcelGeneration"
                    >
                        취소
                    </vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import moment from 'moment';
import store from '@/store/store';
import DatePicker from 'vue2-datepicker';
import ScheduleFilterModal from '@/components/cure/ScheduleFilterModal.vue';
import FilteredScheduleList from '@/components/cure/FilteredScheduleList.vue';
import VacationRow from '@/components/vacation/VacationRow.vue';
import DayFilterButtons from '@/components/common/DayFilterButtons.vue';
import vacationService from '@/services/vacationService';
import { managerFilterMixin } from '@/mixins/managerFilterMixin';
import '../../assets/scss/vuexy/extraComponents/_datePicker.scss'
export default {
    mixins: [managerFilterMixin],
    components: {
      DatePicker,
        Datepicker,
        'v-select': vSelect,
        ScheduleFilterModal,
        FilteredScheduleList,
        VacationRow,
        DayFilterButtons,
    },
    data() {
        return {
            now_date: '',
            prev_date: '',
            next_date: '',
            medical_cd: '',
            popupActive: false,
            time_index: -1,
            tab_menu: [],
            time_data: [],
            cure_data: [],
            cure_count: [],
            date_list: [],
            patient_member_list: [],
            time_list: [],
            select_medical_cd: {},
            select_date: '',
            select_time: '',
            select_user: '',
            options: [],
            now_day: '',
            active: false,
            copy_schedule_seq: -1,
            copy_select_date: '',
            copy_select_time: '',
            memo: '',
            popupActive2: false,
            patientUsername: '',
            patientUid: '',
            patientAge: '',
            patientGender: '',
            medicalRoomNm: '',
            medicalRoomNumberNm: '',
            medicalName: '',
            sickNess: '',
            plan: '',
            chart_no: '',
            status_name: '',
            patient_phone: '',
            in_init_date: '',
            in_date: '',
            out_date: '',
            complate_yn: '',
            meal_name: '',
            medical_nm: '',
            west_medical_nm: '',
            protector_phone: '',
            schedule_seq: -1,
            dc: false,
            dc_memo: '',
            copyChecked: [],
            start_date: '',
            end_date: '',
            tab_options: [],

            detailList: [],
            managerList: [],
            viewDetailList: [],
            viewManagerList: [],
            medicalDetails: [],
            medicalManagers: '',
            loginUid: '',
            tab_sum: 0,
            tab_all_tf: false,
            width: window.innerWidth,
            windowHeight: document.documentElement.clientHeight,
            memo_etc: '',
            awaitTime : '',
            awaitTimeChk : false,
            userUid : '',
            prevScheduleData : {},
            search : '',
            cardTitle : '치료실 스케쥴',
            inLongTerm : 'N',
            isLoading: false,
            
            // 다중 복사 관련 데이터
            multiCopyPopup: false,
            selectedScheduleForCopy: null,
            targetDates: [],
            multiCopyChecked: [],
            
            // 새로운 체크박스 다중 복사 관련 데이터
            bulkCopyMode: false,
            selectedTimeSlots: new Set(), // Set으로 중복 제거 "ymd|time" 형태로 저장
            selectedTimeSlotsList: [], // 체크박스 v-model을 위한 배열
            selectedSchedules: [], // 복사할 스케줄들

            // Excel 비동기 생성 관련 데이터 (2025-12-29)
            useAsyncExcel: true, // Feature flag (롤백용)
            excelGenerating: false,
            excelJobId: null,
            excelProgress: 0,
            excelStatusText: '준비 중...',
            excelStatusMessage: '',
            showExcelProgress: false,
            pollInterval: null,

            // 필터 검색 관련 데이터
            filterModalVisible: false,
            filterMode: false,
            filterCriteria: {
                medicalCd: '',
                date: '',
                hour: ''
            },
            filteredSchedules: [],

            // 날짜 범위 필터 (2025-02-01, 2025-02-24 기본값 3일로 변경)
            // 3=3일(비담당자 기본), 7=주간(담당자 기본)
            // dayFilter: 3, // Mixin에서 제공 (managerFilterMixin)

            // 초기 로드 완료 플래그 (담당자 기반 기본값 설정용)
            // initialLoadDone: false, // Mixin에서 제공

            // 연차 관련 데이터 (2026-02-23)
            vacationMap: new Map(),

            // 무한스크롤 페이지네이션 상태
            scrollOffset: 0,
            hasMoreTimeSlots: true,
            isLoadingMore: false,
            scrollObserver: null,

            // 정적 코드(상세/담당자/탭) 로드 완료 플래그 - 브라우저 HTTP 캐시 활용 (2026-06-12)
            staticCodesLoaded: false,
        };
    },
    methods: {
        // 연차 텍스트 포맷팅 (빨간색 표시) - 2026-02-01
        formatVacationText(text) {
            if (!text) return '';
            // (연차), (오전연차), (오후연차)를 빨간색 span으로 감싸기
            return text.replace(/\((연차|오전연차|오후연차)\)/g, '<span style="color: #e74c3c; font-weight: bold;">($1)</span>');
        },

        /**
         * 연차 정보 로드 (담당자 기준) - 2026-02-23
         */
        async loadVacationData() {
            try {
                // managerList에서 담당자 UID 추출
                let managerUids = this.managerList.map(m => m.MEDICAL_MANAGER_CD);

                // 탭 선택 시 해당 치료실 담당자만 필터
                if (this.medical_cd) {
                    managerUids = this.managerList
                        .filter(m => m.MEDICAL_CD === this.medical_cd)
                        .map(m => m.MEDICAL_MANAGER_CD);
                }

                // 디버깅용 로그
                console.log('[연차 로드] managerUids:', managerUids);
                console.log('[연차 로드] 날짜 범위:', this.start_date, '~', this.end_date);

                if (managerUids.length === 0) {
                    this.vacationMap = new Map();
                    return;
                }

                // 날짜 범위 포맷 (YYYYMMDD -> YYYY-MM-DD)
                const formatDate = (d) => `${d.substring(0,4)}-${d.substring(4,6)}-${d.substring(6,8)}`;

                const newVacationMap = await vacationService.getVacationsByManagers(
                    formatDate(this.start_date),
                    formatDate(this.end_date),
                    managerUids
                );

                // Vue 반응성을 위해 새 Map 할당 - 2026-02-24
                this.vacationMap = new Map(newVacationMap);

                // Vue 2에서 Map 반응성 문제 해결을 위한 강제 업데이트
                this.$forceUpdate();

                // 디버깅용 로그
                console.log('[연차 로드] vacationMap:', this.vacationMap);
                console.log('[연차 로드] vacationMap size:', this.vacationMap.size);
                if (this.vacationMap.size > 0) {
                    this.vacationMap.forEach((value, key) => {
                        console.log('[연차 로드] 날짜:', key, '연차자:', value);
                    });
                }
            } catch (error) {
                console.error('연차 정보 로드 실패:', error);
                this.vacationMap = new Map();
            }
        },

        /**
         * VacationRow용 날짜 키 포맷 함수 - 2026-02-23
         */
        formatDateKeyForVacation(dateItem) {
            // date_list의 항목은 YYYYMMDD 문자열
            if (typeof dateItem === 'string') {
                return dateItem.replace(/-/g, '');
            }
            return '';
        },

        handleResize(event) {
            this.width = window.innerWidth;
            this.windowHeight = document.documentElement.clientHeight;
        },

        /**
         * Mixin에서 호출되는 데이터 리로드 함수
         * @description managerFilterMixin에서 changeDayFilter 시 호출됨
         */
        async reloadData() {
            await this.tabClick(this.medical_cd);
        },
        // Performance optimization: Dynamic patient search (2026-01-19)
        // Replaces loading 20,000+ patients (3.7MB) upfront
        async onPatientSearch(search, loading) {
            if (!search || search.length < 2) {
                this.options = [];
                return;
            }

            if (loading) loading(true);

            try {
                const { data } = await axiosClass.get('/api/patient/list', {
                    userUid: this.userUid,
                    search: search,
                    pageLimit: 50, // Limit to 50 results for performance
                }, true);

                if (data && data.lists) {
                    this.options = data.lists.map(patient => ({
                        id: patient.PATIENT_UID,
                        patientPhone: patient.PATIENT_PHONE,
                        patientName: patient.PATIENT_USERNAME,
                        label: `${patient.MEDICAL_ROOM_NM || ''}-${patient.MEDICAL_ROOM_NUMBER_NM || ''}:${patient.PATIENT_USERNAME}`,
                        oxygenPoint: patient.OXYGEN_POINT || 0,
                        inLongTerm: patient.IN_LONG_TERM || 'N',
                    }));
                } else {
                    this.options = [];
                }
            } catch (error) {
                console.error('[onPatientSearch] Error:', error);
                this.options = [];
            } finally {
                if (loading) loading(false);
            }
        },
        getScheduleRowStyle(schedule) {
            let btn_color = '';
            if (schedule.AWAIT_TIME && schedule.AWAIT_TIME.trim() !== '') {
                return 'background-color:rgba(102, 101, 101,0.3);';
            }

            const medical_nm = schedule.MEDICAL_NM ? schedule.MEDICAL_NM.trim() : '';
            if (medical_nm == '고주파실') {
                btn_color = 'background-color:rgba(128,175,178, 0.3);';
            } else if (medical_nm == '물리치료실') {
                btn_color = 'background-color:rgba(150,180,214, 0.3);';
            } else if (medical_nm == '한의과 침치료') {
                btn_color = 'background-color:rgba(196,164,148, 0.3);';
            } else if (medical_nm == '주열실') {
                btn_color = 'background-color:rgba(201,149,164, 0.3);';
            } else if (medical_nm == '외진') {
                btn_color = 'background-color:rgba(179,167,206, 0.3);';
            } else if (medical_nm == '외출') {
                btn_color = 'background-color:rgba(185,232,239,0.3);';
            } else if (medical_nm == '말초신경클리닉') {
                btn_color = 'background-color:rgba(204,216,195,0.3);';
            } else if (medical_nm == '마사지실') {
                btn_color = 'background-color:rgba(224,227,154,0.3);';
            } else {
                btn_color = 'background-color:rgba(226,164,147,0.3);';
            }
            return btn_color;
        },
        // 정적 코드(상세/담당자/탭) 로드 - 브라우저 HTTP 캐시(1시간) 활용 (2026-06-12)
        // 거의 변경되지 않으므로 1회만 호출. 변경 시 강력 새로고침(Cmd+Shift+R)으로 갱신.
        async loadStaticCodes() {
            if (this.staticCodesLoaded) return;
            const { data } = await axiosClass.get('/api/cure/static-codes', {}, true);
            this.detailList = data.detailList || [];
            this.managerList = data.managerList || [];

            // 탭 메뉴 구성 (TAB_CODE 활성 항목만, ORDER_INT 정렬)
            this.tab_menu = [];
            const rawTabMenu = data.tab_menu || [];
            for (let i = 0; i < rawTabMenu.length; i++) {
                if (rawTabMenu[i].TAB_CODE != false) {
                    this.tab_menu.push(rawTabMenu[i]);
                }
            }
            this.tab_menu.sort((a, b) => (a.ORDER_INT || 0) - (b.ORDER_INT || 0));
            if (rawTabMenu.length <= this.tab_menu.length) this.tab_all_tf = true;

            this.tab_options = [];
            for (let i = 0; i < this.tab_menu.length; i++) {
                this.tab_options.push({
                    id: this.tab_menu[i].MEDICAL_CD,
                    label: this.tab_menu[i].MEDICAL_NM,
                });
            }

            this.staticCodesLoaded = true;
        },
        async init(date) {
            this.now_day = dateClass.nowday();
            if (date == '') {
                this.now_date = dateClass.dateYYYYMMDD();
            } else {
                this.now_date = date;
            }
            this.userUid = store.getters.getUID;
            // this.now_date = '20210510';
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            // 무한스크롤 초기화
            this.scrollOffset = 0;
            this.hasMoreTimeSlots = true;
            this.isLoadingMore = false;
            this.teardownScrollObserver();

            // 정적 코드(상세/담당자/탭) 로드 - 1회만, 브라우저 HTTP 캐시 활용 (2026-06-12)
            await this.loadStaticCodes();

            let jsonData = {
                uid: this.loginUid,
                days: this.dayFilter,
                offset: 0,
                limit: this.scrollLimit, // 무한스크롤: 초기엔 화면높이만큼 시간대만 (저사양 DOM 부담 완화, 2026-06-12)
            };
            const { data } = await axiosClass.get('/api/cure/listV2/' + this.now_date, jsonData, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.tab_sum = data.memberData.TAB_SUM_01;
            this.date_list = data.date_list;
            this.cure_data = data.cure_data;
            this.hasMoreTimeSlots = data.has_more;
            this.scrollOffset = data.cure_data.length;
            this.cure_count = data.cure_count;

            this.start_date = this.date_list[0];
            this.end_date = this.date_list[this.date_list.length - 1];

            // 담당자 기반 기본 필터 설정 (첫 로드 시에만) - 2025-02-24
            if (!this.initialLoadDone) {
                const needsReload = this.applyDefaultFilterByManager();
                if (needsReload) {
                    // 담당자인 경우 해당 치료실 + 7일로 다시 로드
                    await this.tabClick(this.medical_cd);
                    return;
                }
            }

            // 연차 정보 로드 (담당자 기준) - 2026-02-23
            await this.loadVacationData();

            setTimeout(function() {
                var element = document.getElementById(dateClass.dateYYYYMMDD());
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                }
            }, 500);

            this.$nextTick(() => {
                this.setupScrollObserver();
            });
        },
        async tabClick(medical_cd) {
            // 필터 모드가 활성화되어 있으면 리셋
            if (this.filterMode) {
                this.resetFilter();
            }

            // 무한스크롤 초기화
            this.scrollOffset = 0;
            this.hasMoreTimeSlots = true;
            this.isLoadingMore = false;
            this.teardownScrollObserver();

            // 정적 코드는 1회 로드(브라우저 캐시) - 단독 호출 대비 가드 (2026-06-12)
            await this.loadStaticCodes();

            this.medical_cd = medical_cd;
            const params = {
                medical_cd: medical_cd,
                uid: this.loginUid,
                days: this.dayFilter,
                offset: 0,
                limit: this.scrollLimit, // 무한스크롤: 초기엔 화면높이만큼 시간대만 (저사양 DOM 부담 완화, 2026-06-12)
            };
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            const { data } = await axiosClass.get('/api/cure/listV2/' + this.now_date, params, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.date_list = data.date_list;
            this.cure_data = data.cure_data;
            this.hasMoreTimeSlots = data.has_more;
            this.scrollOffset = data.cure_data.length;
            this.cure_count = data.cure_count;

            this.start_date = this.date_list[0];
            this.end_date = this.date_list[this.date_list.length - 1];

            const selectedItem = this.tab_menu.find((item) => item.MEDICAL_CD === this.medical_cd);
            if (selectedItem) {
                document.title = selectedItem.MEDICAL_NM + ' - ' + document.title.substring(document.title.indexOf("치료실 스케쥴")); // 타이틀 변경
                this.cardTitle = selectedItem.MEDICAL_NM + ' - ' + this.cardTitle.substring(this.cardTitle.indexOf("치료실 스케쥴"))  ;
            } else {
                document.title = document.title.substring(document.title.indexOf("치료실 스케쥴"));
                this.cardTitle = this.cardTitle.substring(this.cardTitle.indexOf("치료실 스케쥴"));
            }

            // 연차 정보 다시 로드 (선택된 치료실 담당자 기준) - 2026-02-23
            await this.loadVacationData();

            this.$nextTick(() => {
                this.setupScrollObserver();
            });
        },

        async loadMoreTimeSlots() {
            if (this.isLoadingMore || !this.hasMoreTimeSlots) return;
            this.isLoadingMore = true;
            try {
                const params = {
                    medical_cd: this.medical_cd,
                    uid: this.loginUid,
                    days: this.dayFilter,
                    offset: this.scrollOffset,
                    limit: this.scrollLimit,
                };
                const { data } = await axiosClass.get('/api/cure/listV2/' + this.now_date, params, true);
                this.cure_data = this.cure_data.concat(data.cure_data);
                this.hasMoreTimeSlots = data.has_more;
                this.scrollOffset += data.cure_data.length;
            } catch (e) {
                console.error('[loadMoreTimeSlots] Error:', e);
            } finally {
                this.isLoadingMore = false;
            }
            // 데이터가 더 있지만 스크롤이 안 생기는 경우 observer 재설정으로 추가 로드
            if (this.hasMoreTimeSlots) {
                this.$nextTick(() => {
                    this.setupScrollObserver();
                });
            }
        },
        setupScrollObserver() {
            this.teardownScrollObserver();
            const scrollContainer = document.getElementById('calendarDiv');
            if (!scrollContainer) return;
            // IntersectionObserver가 이 구조(작은 root + 중첩 테이블)에서 트리거되지 않아
            // scroll 이벤트 기반 하단 근접 감지로 교체 (2026-07-02, 실측 검증)
            this._scrollHandler = () => {
                if (!this.hasMoreTimeSlots || this.isLoadingMore) return;
                if (scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 200) {
                    this.loadMoreTimeSlots();
                }
            };
            scrollContainer.addEventListener('scroll', this._scrollHandler, { passive: true });
            // 초기 콘텐츠가 컨테이너를 못 채워 스크롤이 불가능하면 자동으로 다음 페이지 로드
            this.$nextTick(() => {
                if (this.hasMoreTimeSlots && !this.isLoadingMore &&
                    scrollContainer.scrollHeight <= scrollContainer.clientHeight + 200) {
                    this.loadMoreTimeSlots();
                }
            });
        },
        teardownScrollObserver() {
            if (this.scrollObserver) {
                this.scrollObserver.disconnect();
                this.scrollObserver = null;
            }
            if (this._scrollHandler) {
                const sc = document.getElementById('calendarDiv');
                if (sc) sc.removeEventListener('scroll', this._scrollHandler);
                this._scrollHandler = null;
            }
        },

        async calendarSave() {
            // console.log(this.medicalDetails.length);
            let errorMsg = '';
            if (this.select_date == '--') {
                this.select_date = '';
            }

            if (this.select_medical_cd.id == undefined || this.select_medical_cd.id == '') {
                errorMsg = '치료실을 선택하여 주십시오.';
            } else if (this.select_date == '') {
                errorMsg = '날짜를 선택해주세요.';
            } else if (this.select_time == '') {
                errorMsg = '시간을 입력해주세요.';
            } else if (this.viewManagerList.length > 0) {
                if (this.medicalManagers == '') {
                    errorMsg = '치료자를 선택하여 주십시오.';
                }
            }

            if (this.select_user.length == 0) {
                errorMsg = '환자를 선택하여 주십시오.';
            }

            // else if (this.viewDetailList.length > 0) {
            //     if (this.medicalDetails == '') {
            //         errorMsg = '스케줄을 선택하여 주십시오.';
            //     }
            // }
            //    console.log(this.select_time)
            if (errorMsg != '') {
                this.$vs.notify({
                    title: 'Error',
                    text: errorMsg,
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }
            if(this.select_medical_cd.id == "01013" || this.select_medical_cd.id == "01014") {
                if(this.select_user.oxygenPoint < 1) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'green',
                        title: '확인',
                        text: '포인트가 부족합니다. \n그래도 예약하시겠습니까?',
                        position: 'center',
                        acceptText: '네',
                        cancelText: '취소',
                        accept : () => {
                            this.checkOxygenCount(this.select_date, this.select_time, 'save');
                            //this.saveLogic();
                        },
                        cancel: function() {
                            return;
                        }
                    });
                } else {
                    //this.saveLogic ()
                    this.checkOxygenCount(this.select_date, this.select_time, 'save');
                }
            } else {
                this.saveLogic()
            }
        },
        async checkOxygenCount (date, time, divn) {
            var selectedDate = date.replace(/-/g, "");
            var selectedTime = time;
            const jsonData = {
                selectedDate: selectedDate, 
                selectedTime: selectedTime,
                selectedMedicalCode : this.select_medical_cd.id
            }
            if(this.dc == false || this.awaitTime == '') {
                const { data } = await axiosClass.get('/api/cure/checkOxygenCount/'+ selectedDate +'/'+selectedTime+'/'+this.select_medical_cd.id, jsonData, true );
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);
                
                let viewMsg = '';
                if(divn == 'save'){
                    viewMsg = '이미 해당 시간 정원이 찼습니다. \n그래도 저장하시겠습니까?'
                } else if(divn == 'copy') {
                    viewMsg = '이미 해당 시간 정원이 찼습니다. \n그래도 복사하시겠습니까?'
                }

                if(data.oxygenCount.COUNT >= 6 && (this.awaitTime == '' && this.dc == false)) {
                    if(divn == 'save'){
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'green',
                            title: '확인',
                            text: viewMsg,
                            position: 'center',
                            acceptText: '네',
                            cancelText: '취소',
                            accept : () => {
                                    this.saveLogic();
                            },
                            cancel: function() {
                                return;
                            }
                        });
                    } else if(divn == 'copy') {
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'green',
                            title: '확인',
                            text: viewMsg,
                            position: 'center',
                            acceptText: '네',
                            cancelText: '취소',
                            accept : () => {
                                    this.DataCopy();
                                
                            },
                            cancel: function() {
                                return;
                            }
                        });
                    }
                    
                    
                } else {
                    if(divn == 'save'){
                        this.saveLogic();
                    } else if(divn == 'copy') {
                        this.DataCopy();
                    }
                }
               
            } else {
                if(divn == 'save'){
                    this.saveLogic();
                } else if(divn == 'copy') {
                    this.DataCopy();
                }
            }
        },
        async saveLogic () {
            const memo = document.getElementById('memo').value;
            let select_time = document.getElementById('select_time').value;

            if (isNaN(select_time) == false) {
                this.select_time = select_time;
            }

            let dcString = '';
            if (this.dc == false) {
                dcString = 'N';
            } else {
                dcString = 'Y';
            }
            const jsonData = {
                select_medical_cd: this.select_medical_cd,
                select_date: this.select_date,
                select_time: this.select_time,
                select_user: JSON.stringify(this.select_user),
                tab_medical_cd: this.medical_cd,
                memo: memo,
                schedule_seq: this.schedule_seq,
                dc: dcString,
                dc_memo: this.dc_memo,
                medicalDetails: this.medicalDetails.join(),
                medicalManagers: this.medicalManagers,
                memo_etc: this.memo_etc,
                awaitTime : this.awaitTime + '',
                prevScheduleData : this.prevScheduleData,
                days: this.dayFilter
            };
            
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });
            //console.log(jsonData);
            const { data } = await axiosClass.post('/api/cure/saveV2', jsonData, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;
            this.initPopupData();

            this.date_list = data.date_list;
            this.cure_data = data.cure_data;
            this.cure_count = data.cure_count;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
        async clipCopy(item) {
            // console.log(item);
            // console.log(document.getElementById(item.schedule_seq).getElementsByClassName('con-vs-chip')[0].style);
            const div = document.getElementsByClassName('con-vs-chip');
            for (let i = 0; i < div.length; i++) {
                div[i].classList.remove('selectOn');
            }

            this.copy_schedule_seq = -1;
            if (
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.contains('selectOn')
            ) {
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.remove('selectOn');
            } else {
                document
                    .getElementById(item.schedule_seq)
                    .getElementsByClassName('con-vs-chip')[0]
                    .classList.add('selectOn');
            }

            this.copy_schedule_seq = item.schedule_seq;
        },

        async clipCopyConfirm(ymd, time) {
            // console.log(this.copy_schedule_seq + '///' + ymd + '///' + time);

            this.copy_select_date = ymd;
            this.copy_select_time = time;

            if (this.copyChecked.length == 0) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 컨텐츠를 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }
            if(this.select_medical_cd.id == "01013" || this.select_medical_cd.id == "01014") {
                if(this.select_user.oxygenPoint < 1) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'green',
                        title: '확인',
                        text: '포인트가 부족합니다. \n그래도 복사하시겠습니까?',
                        position: 'center',
                        acceptText: '네',
                        cancelText: '취소',
                        accept :  () => {this.checkOxygenCount(this.copy_select_date, this.copy_select_time, 'copy')},
                        cancel: function() {
                            return;
                        }
                    });
                } else {
                    this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: '복사',
                    text: '선택한 예약을 복사하시겠습니까?',
                    acceptText: '복사',
                    cancelText: '취소',
                    accept:  () => {this.checkOxygenCount(this.copy_select_date, this.copy_select_time, 'copy')},
                    cancel: function() {
                        return;
                    },
                    });
                }
            } else {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: '복사',
                    text: '선택한 예약을 복사하시겠습니까?',
                    acceptText: '복사',
                    cancelText: '취소',
                    accept:  () => {this.checkOxygenCount(this.copy_select_date, this.copy_select_time, 'copy')},
                    cancel: function() {
                        return;
                    },
                    });
            }
            
            // document.getElementsByClassName('con-vs-chip').classList.remove('selectOn');
        },

        async DataCopy() {
            const jsonData = {
                copy_date: this.copyChecked,
                ymd: this.copy_select_date,
                time: this.copy_select_time,
                medical_cd: this.medical_cd,
                days: this.dayFilter,
            };
            //const {patientData}  = await axiosClass.post('/api/cure/selectSchedule', jsonData, true);
            //console.log(patientData);
            
            const { data } = await axiosClass.post('/api/cure/copyV2', jsonData, true);

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            this.popupActive = false;
            this.initPopupData();
            this.copyChecked = [];
            this.date_list = data.date_list;
            this.cure_data = data.cure_data;
            this.cure_count = data.cure_count;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            const div = document.getElementsByClassName('con-vs-chip');
            for (let i = 0; i < div.length; i++) {
                div[i].classList.remove('selectOn');
            }
            this.copy_schedule_seq = -1;
        },

        async calendarTdClick(item, schedule_item) {
            // console.log(this.medical_cd);
            this.select_time = item.CODE_TIME;
            this.select_date = this.customFormatter(schedule_item);
            // console.log(this.medical_cd);

            this.select_user = '';
            await this.popupOpen();

            // this.select_medical_cd = this.medical_cd;

            for (let i = 0; i < this.tab_options.length; i++) {
                if (this.tab_options[i].id == this.medical_cd) {
                    this.select_medical_cd = this.tab_options[i];
                }
            }
        },
        // 스케줄 등록 팝업 데이터 초기화
        initPopupData() {
            this.schedule_seq = -1;
            this.dc = false;
            this.dc_memo = '';
            this.select_date = '';
            this.select_time = '';
            this.awaitTimeChk = false;
            this.awaitTime = '';
            if (document.getElementById('memo')) {
                document.getElementById('memo').value = '';
            }
            this.options = [];
            this.select_medical_cd = {};
            this.select_user = null;
            this.inLongTerm = 'N';
            this.viewDetailList = [];
            this.viewManagerList = [];
            this.medicalDetails = [];
            this.medicalManagers = '';
            this.memo_etc = '';
        },
        async popupOpen(day, time) {
            this.initPopupData();
            if (day) {
                this.select_date = day.substring(0, 4) + '-' + day.substring(4, 6) + '-' + day.substring(6, 8);
            }
            this.select_time = time;
            const { data } = await axiosClass.get('/api/cure/select', {}, true);
            // console.log(data);
            this.time_list = data.timeList;

            for (let i = 0; i < this.tab_options.length; i++) {
                if (this.tab_options[i].id == this.medical_cd) {
                    this.select_medical_cd = this.tab_options[i];
                }
            }

            this.select_medical_input();

            this.popupActive = true;
        },

        async memberView(uid) {
            this.$EventBus.$emit('memberView', uid);
        },

        async popupmodify(item) {
            this.isLoading = true;
            //console.log(item)
            this.schedule_seq = item.SCHEDULE_SEQ;
            // this.popupActive = true;
            //console.log(item)
            
            const { data } = await axiosClass.get('/api/cure/schedule/' + item.SCHEDULE_SEQ, {}, true);
            this.prevScheduleData = item;
            this.time_list = data.timeList;
            // this.popupActive = true;
            this.options = [];
            // this.select_medical_cd = this.medical_cd;
            this.select_user = '';
            //console.log(data)
            for (let i = 0; i < data.memberList.length; i++) {
                this.options.push({
                    id: data.memberList[i].PATIENT_UID,
                    patientPhone : data.memberList[i].PATIENT_PHONE,
                    patientName : data.memberList[i].PATIENT_USERNAME,
                    label: data.memberList[i].MEDICAL_ROOM_NM + '-' + data.memberList[i].MEDICAL_ROOM_NUMBER_NM + ':' + data.memberList[i].PATIENT_USERNAME,
                    oxygenPoint : data.memberList[i].OXYGEN_POINT,
                    inLongTerm : data.memberList[i].IN_LONG_TERM,
                });

                if (data.memberList[i].PATIENT_UID == data.selectData.PATIENT_UID) {
                    this.select_user = this.options[i];
                    this.inLongTerm = this.select_user.inLongTerm;
                }
            }
            
            // this.select_medical_cd = data.selectData.MEDICAL_CODE;
            for (let i = 0; i < this.tab_options.length; i++) {
                if (this.tab_options[i].id == data.selectData.MEDICAL_CODE) {
                    this.select_medical_cd = this.tab_options[i];
                }
            }
            this.dc_memo = data.selectData.DC_MEMO;
            if (data.selectData.DC == '' || data.selectData.DC == 'N') {
                this.dc = false;
            } else {
                this.dc = true;
            }
            
            document.getElementById('memo').value = data.selectData.MEMO || '';

            if (data.selectData.DC == 'Y') {
                this.dc = true;
            } else {
                this.dc = false;
            }
            this.awaitTime = data.selectData.AWAIT_TIME || '';
            this.awaitTimeChk = this.awaitTime ? true : false;
            this.dc_memo = data.selectData.DC_MEMO;
            
            this.select_date = data.selectData.YMD_STRING.substring(0, 4) + '-' + data.selectData.YMD_STRING.substring(4, 6) + '-' + data.selectData.YMD_STRING.substring(6, 8);
            this.select_time = data.selectData.REAL_TIME_STRING || '';

            if (data.selectData.MEDICAL_DETAILS != '') this.medicalDetails = data.selectData.MEDICAL_DETAILS.split(',');
            if (data.selectData.MEDICAL_MANAGERS != '') this.medicalManagers = data.selectData.MEDICAL_MANAGERS;

            this.select_medical_input();
            this.popupActive = true;
            this.isLoading = false;

            // console.log(this.options);
            // console.log('data2:' + document.getElementById('memo').value);
        },

        select_medical_input(value) {
            //console.log(this.select_medical_cd.id);
            this.viewDetailList = [];

            for (let i = 0; i < this.detailList.length; i++) {
                if (this.detailList[i].MEDICAL_CD == this.select_medical_cd.id) {
                    this.viewDetailList.push(this.detailList[i]);
                }
            }

            this.viewManagerList = [];
            for (let i = 0; i < this.managerList.length; i++) {
                if (this.managerList[i].MEDICAL_CD == this.select_medical_cd.id) {
                    this.viewManagerList.push(this.managerList[i]);
                }
            }
            //console.log(this.viewManagerList);
            if (!this.isLoading) {
                this.medicalDetails = [];
                // 첫 번째 치료자를 기본 선택
                this.medicalManagers = this.viewManagerList.length > 0 ? this.viewManagerList[0].MEDICAL_MANAGER_CD : '';
            }
            // console.log('this.detailValue:::', this.medicalDetails);
            if(this.dc == true || this.awaitTime != '') {
                return null;
            }

            if (!this.isLoading && this.select_time) {
                if(value) {
                    if(value.id == '01014') {
                        this.select_time = this.select_time.substring(0,2) + '30'
                    } else if(value.id == '01013'){
                        this.select_time = this.select_time.substring(0,2) + '00'
                    } else {
                        this.select_time = this.select_time.substring(0,2) + '00'
                    }
                } else {
                    if(this.medical_cd == '01014') {
                        this.select_time = this.select_time.substring(0,2) + '30'
                    } else if(this.medical_cd == '01013'){
                        this.select_time = this.select_time.substring(0,2) + '00'
                    } else {
                        this.select_time = this.select_time.substring(0,2) + '00'
                    }
                }
            }
        },

        async curePlan(schedule_seq) {
            // console.log(schedule_seq);
            const { data } = await axiosClass.post('/api/cure/select/' + schedule_seq, {}, true);
            // console.log(data.cure_plan['PATIENT_USERNAME']);
            if (data.cure_plan['PLAN'] == '') {
                data.cure_plan['PLAN'] = '없음';
            }
            this.popupActive = false;
            let _this = this;
            _this.$vs.dialog({
                color: 'primary',
                title: data.cure_plan['PATIENT_USERNAME'] + '님 치료플랜',
                text: data.cure_plan['PLAN'],
                acceptText: '닫기',
            });
        },
        async memberReport(uid) {
            const { data } = await axiosClass.get('/api/remote/userData/' + uid, {}, true);
            // console.log(uid);
            // console.log(data);
            this.popupActive2 = true;
            this.patientUsername = data.patientData.PATIENT_USERNAME;
            this.patientAge = data.patientData.PATIENT_AGE;
            this.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
            this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;
            this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
            this.medicalName = data.patientData.MEDICAL_NAME;
            this.sickNess = data.patientData.SICKNESS;
            this.plan = data.patientData.PLAN;
            this.memo = data.patientData.MEMO;
            this.chart_no = data.patientData.CHART_NO;
            this.status_name = data.patientData.STATUS_NAME;
            this.patient_phone = data.patientData.PATIENT_PHONE;
            this.in_init_date = data.patientData.IN_INIT_DATE;
            this.in_date = data.patientData.IN_DATE;
            this.out_date = data.patientData.OUT_DATE;
            this.complate_yn = data.patientData.COMPLATE_YN;
            this.meal_name = data.patientData.MEAL_NAME;
            this.medical_nm = data.patientData.MEDICAL_NM;
            d;
            this.west_medical_nm = data.patientData.WEST_MEDICAL_NAME;
            this.protector_phone = data.patientData.PROTECTOR_PHONE;
            // console.log(data);
        },
        popupClose() {
            this.popupActive = false;
        },

        dayReturn(item) {
            const week = ['일', '월', '화', '수', '목', '금', '토'];
            const weekString = week[new Date(item.substring(0, 4) + '-' + item.substring(4, 6) + '-' + item.substring(6, 8)).getDay()];
            return parseInt(item.substring(4, 6)) + '월 / ' + parseInt(item.substring(6, 8)) + '일(' + weekString + ')';
        },

        async calendarTdDelete(item) {
            //console.log(item);
            this.select_schedule_seq = item.SCHEDULE_SEQ;
            this.medical_cd = item.MEDICAL_CODE;
            this.patientUid = item.PATIENT_UID;
            this.popupActive = false;
            let _this = this;
            _this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '예약된 치료실(' + item.MEDICAL_ROOM_NUMBER_NM + '-' + item.PATIENT_USERNAME + ')를 정말로 삭제하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: _this.calendarDelete,
            });
            
        },

        async calendarDelete() {
            if (this.now_date == '') {
                this.now_date = dateClass.dateYYYYMM();
            }
            //console.log(store.getters.getUID);
            //console.log(this.medical_cd);
            //console.log(this.patientUid);
            const jsonData = {
                select_date: this.now_date,
                patientId : this.patientUid,
                tab_medical_cd: this.medical_cd,
                regId : store.getters.getUID,
                days: this.dayFilter,
            };
            // console.log(this.select_schedule_seq);
            
            const { data } = await axiosClass.delete('/api/cure/deleteV2/' + this.select_schedule_seq, jsonData, true);
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);

            // console.log(data);

            this.popupActive = false;

            this.date_list = data.date_list;
            this.cure_data = data.cure_data;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 삭제되었습니다.',
                color: 'danger',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            this.patientUid = '';
            this.select_schedule_seq = '';
            //this.medical_cd = '';
        },
        prevMonth() {
            // 필터 모드가 활성화되어 있으면 리셋
            if (this.filterMode) {
                this.resetFilter();
            }

            this.now_date = this.prev_date;
            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.tabClick(this.medical_cd);
        },
        nextMonth() {
            // 필터 모드가 활성화되어 있으면 리셋
            if (this.filterMode) {
                this.resetFilter();
            }

            this.now_date = this.next_date;

            this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
            this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
            this.tabClick(this.medical_cd);
        },
      updateDate(day) {
        if (day) {
          // 필터 모드가 활성화되어 있으면 리셋
          if (this.filterMode) {
              this.resetFilter();
          }

          this.now_date = day;
          this.prev_date = dateClass.prevYYYYMMDD7(this.now_date);
          this.next_date = dateClass.nextYYYYMMDD7(this.now_date);
          this.tabClick(this.medical_cd);
        }
      },
        activeMenu(medical_code) {
            if (medical_code == this.medical_cd) {
                return 'activeMenu';
            } else {
                return '';
            }
        },

        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        setAwaitTime() {
            if(this.awaitTimeChk == true) {
                this.awaitTime = moment().format('YYYY-MM-DD HH:mm:ss');
            } else {
                this.awaitTime = '';
            }
            
        },
        async searchPatient (value) {
            if (!value) return;
            
            let params = {
                search_name : value
            }

            const { data } = await axiosClass.get(
                "/api/patient/search_patientList",
                params,
                true
            );
            
            this.options = data.data.map(item => ({
                id: item.PATIENT_UID,
                patientPhone : item.PATIENT_PHONE,
                patientName : item.PATIENT_USERNAME,
                patientUid : item.PATIENT_UID,
                oxygenPoint : item.OXYGEN_POINT || 0,
                inLongTerm : item.IN_LONG_TERM || 'N',
                label: (item.MEDICAL_ROOM_NM != '' ? item.MEDICAL_ROOM_NM + '-' + item.MEDICAL_ROOM_NUMBER_NM + ' : ' : '') + item.CHART_NO + '/' + item.PATIENT_USERNAME + '('+ item.PATIENT_PHONE.substr(9,4) + ')',
            }));
        },
        resetOption () {
            this.options=[];
        },

        // 다중 복사 관련 새로운 메서드들
        openMultiCopyModal(ymd, time) {
            this.selectedScheduleForCopy = {
                ymd: ymd,
                time: time
            };
            this.multiCopyChecked = [];
            this.targetDates = [{ date: '', time: '' }];
            this.multiCopyPopup = true;
        },

        getSelectedSchedulesForMultiCopy() {
            if (!this.selectedScheduleForCopy) return [];
            
            const ymd = this.selectedScheduleForCopy.ymd;
            const time = this.selectedScheduleForCopy.time;
            
            // 해당 시간대의 모든 스케줄을 찾아서 반환
            for (let i = 0; i < this.cure_data.length; i++) {
                if (this.cure_data[i].code_time === time) {
                    const schedules = this.cure_data[i].schedules_by_day[ymd];
                    return schedules || [];
                }
            }
            return [];
        },

        addTargetDate() {
            this.targetDates.push({ date: '', time: '' });
        },

        removeTargetDate(index) {
            this.targetDates.splice(index, 1);
        },

        closeMultiCopyModal() {
            this.multiCopyPopup = false;
            this.selectedScheduleForCopy = null;
            this.multiCopyChecked = [];
            this.targetDates = [];
        },

        async executeMultiCopy() {
            if (this.multiCopyChecked.length === 0) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 스케줄을 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            // 날짜/시간 입력 검증 (Date 객체도 고려)
            const hasEmptyFields = this.targetDates.some(t => {
                const hasDate = t.date && (typeof t.date === 'string' || t.date instanceof Date);
                const hasTime = t.time && t.time.trim() !== '';
                return !hasDate || !hasTime;
            });

            if (this.targetDates.length === 0 || hasEmptyFields) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 날짜와 시간을 모두 입력해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            // 산소실 체크 로직이 있는 경우
            const hasOxygenSchedule = this.multiCopyChecked.some(seq => {
                const schedules = this.getSelectedSchedulesForMultiCopy();
                const schedule = schedules.find(s => s.SCHEDULE_SEQ === seq);
                return schedule && (schedule.MEDICAL_CODE === '01013' || schedule.MEDICAL_CODE === '01014');
            });

            if (hasOxygenSchedule) {
                await this.checkMultiCopyOxygenCount();
            } else {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'primary',
                    title: '다중 복사',
                    text: `선택한 스케줄을 ${this.targetDates.length}개 날짜/시간으로 복사하시겠습니까?`,
                    acceptText: '복사',
                    cancelText: '취소',
                    accept: () => {
                        this.executeMultiDataCopy();
                    }
                });
            }
        },

        async checkMultiCopyOxygenCount() {
            // 산소실 정원 체크 로직 (필요시 구현)
            this.executeMultiDataCopy();
        },

        async executeMultiDataCopy() {
            const targetDatesFormatted = this.targetDates.map(target => {
                // Date 객체인 경우 문자열로 변환
                let dateString = target.date;
                if (target.date instanceof Date) {
                    dateString = this.customFormatter(target.date);
                }
                return {
                    date: dateString.replace(/-/g, ''),
                    time: target.time
                };
            });

            const jsonData = {
                source_schedule_seqs: this.multiCopyChecked,
                target_dates_times: targetDatesFormatted,
                medical_cd: this.medical_cd,
                send_sms: true,
                days: this.dayFilter,
            };

            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            try {
                const { data } = await axiosClass.post('/api/cure/multiCopyV2', jsonData, true);
                
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);

                this.closeMultiCopyModal();
                
                // 데이터 새로고침
                this.date_list = data.date_list;
                this.cure_data = data.cure_data;
                this.cure_count = data.cure_count;

                this.$vs.notify({
                    title: 'Success',
                    text: '다중 복사가 완료되었습니다.',
                    color: 'success',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
            } catch (error) {
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);

                this.$vs.notify({
                    title: 'Error',
                    text: '다중 복사 중 오류가 발생했습니다.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-x',
                });
            }
        },

        // 새로운 체크박스 다중 복사 관련 메서드들
        toggleBulkCopyMode() {
            this.bulkCopyMode = !this.bulkCopyMode;
            if (!this.bulkCopyMode) {
                // 모드 해제 시 선택 초기화
                this.selectedTimeSlots.clear();
                this.selectedTimeSlotsList = [];
                this.selectedSchedules = [];
            }
        },

        updateSelectedTimeSlots() {
            this.selectedTimeSlots.clear();
            this.selectedTimeSlotsList.forEach(slot => {
                this.selectedTimeSlots.add(slot);
            });
        },

        getSelectedSchedulesInfo() {
            const selectedSchedulesInfo = [];
            for (let i = 0; i < this.cure_data.length; i++) {
                for (let date of this.date_list) {
                    const schedules = this.cure_data[i].schedules_by_day[date];
                    if (schedules) {
                        schedules.forEach(schedule => {
                            if (this.selectedSchedules.includes(schedule.SCHEDULE_SEQ)) {
                                selectedSchedulesInfo.push(schedule);
                            }
                        });
                    }
                }
            }
            return selectedSchedulesInfo;
        },


        async executeBulkCopy() {
            if (this.selectedSchedules.length === 0) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 스케줄을 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            if (this.selectedTimeSlots.size === 0) {
                this.$vs.notify({
                    title: '확인',
                    text: '복사할 날짜/시간을 선택해주세요.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }

            // 선택된 시간대를 targetDatesFormatted 형식으로 변환
            const targetDatesFormatted = Array.from(this.selectedTimeSlots).map(slot => {
                const [date, time] = slot.split('|');
                return {
                    date: date,
                    time: time
                };
            });


            // 선택된 스케줄 정보 생성 (줄바꿈 포함)
            const selectedSchedulesInfo = this.getSelectedSchedulesInfo();
            const scheduleList = selectedSchedulesInfo.map(schedule => {
                const timeStr = schedule.REAL_TIME_STRING.substring(0, 2) + ':' + schedule.REAL_TIME_STRING.substring(2, 4);
                const medicalName = schedule.MEDICAL_NM ? `[${schedule.MEDICAL_NM.substring(0, 1)}]` : '';
                return `${timeStr} ${medicalName} ${schedule.MEDICAL_ROOM_NUMBER_NM} ${schedule.PATIENT_USERNAME}`;
            });

            // 선택된 날짜/시간 정보 생성 (줄바꿈 포함)
            const dateTimeList = targetDatesFormatted.map(target => {
                const dateFormatted = target.date.substring(4, 6) + '/' + target.date.substring(6, 8);
                const timeFormatted = target.time.substring(0, 2) + ':' + target.time.substring(2, 4);
                return `${dateFormatted} ${timeFormatted}`;
            });

            // 산소실 체크 로직
            const hasOxygenSchedule = this.selectedSchedules.some(seq => {
                // 선택된 스케줄 중 산소실 스케줄이 있는지 확인
                for (let i = 0; i < this.cure_data.length; i++) {
                    for (let date of this.date_list) {
                        const schedules = this.cure_data[i].schedules_by_day[date];
                        if (schedules) {
                            const schedule = schedules.find(s => s.SCHEDULE_SEQ === seq);
                            if (schedule && (schedule.MEDICAL_CODE === '01013' || schedule.MEDICAL_CODE === '01014')) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            });

            // 가독성이 좋은 확인 메시지 템플릿
            const confirmMessage = `복사할 스케쥴 :
${scheduleList.join('\n')}

복사할 날짜/시간 :
${dateTimeList.join('\n')}
`;

            // 간단한 confirm 창으로 대체 (브라우저 기본 창은 줄바꿈을 지원함)
            const confirmText = confirmMessage + (hasOxygenSchedule ? '\n※ 산소포인트가 차감됩니다.' : '');
            
            if (confirm(confirmText)) {
                this.executeBulkDataCopy(targetDatesFormatted);
            }
        },

        async executeBulkDataCopy(targetDatesFormatted) {
            const jsonData = {
                source_schedule_seqs: this.selectedSchedules,
                target_dates_times: targetDatesFormatted,
                medical_cd: this.medical_cd,
                send_sms: true,
                days: this.dayFilter,
            };

            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            try {
                const { data } = await axiosClass.post('/api/cure/bulkCopyV3', jsonData, true);
                
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);

                // 복사 완료 후 초기화
                this.selectedSchedules = [];
                this.selectedTimeSlots.clear();
                this.selectedTimeSlotsList = [];
                this.bulkCopyMode = false;
                
                // 데이터 새로고침
                this.date_list = data.date_list;
                this.cure_data = data.cure_data;
                this.cure_count = data.cure_count;

                this.$vs.notify({
                    title: 'Success',
                    text: '체크박스 다중 복사가 완료되었습니다.',
                    color: 'success',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
            } catch (error) {
                setTimeout(() => {
                    this.$vs.loading.close('#schedule > .con-vs-loading');
                }, 100);

                this.$vs.notify({
                    title: 'Error',
                    text: '체크박스 다중 복사 중 오류가 발생했습니다.',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-x',
                });
            }
        },

        // ============================================================
        // ASYNC EXCEL EXPORT METHODS (2025-12-29)
        // ============================================================

        /**
         * Request async Excel generation
         */
        async requestExcelGeneration() {
            // Feature flag check - can be disabled for rollback
            if (!this.useAsyncExcel) {
                // Fallback to sync download
                window.location.href = `/api/cure/excel/${this.now_date}?medical_cd=${this.medical_cd}`;
                return;
            }

            this.excelGenerating = true;
            this.showExcelProgress = true;
            this.excelProgress = 10;
            this.excelStatusText = '작업 생성 중...';

            try {
                // Create async job
                const { data } = await axiosClass.post(
                    `/api/cure/excel/async/${this.now_date}?medical_cd=${this.medical_cd}`,
                    {},
                    true
                );

                this.excelJobId = data.job_id;
                this.excelProgress = 20;
                this.excelStatusText = 'Excel 생성 중...';
                this.excelStatusMessage = '데이터 조회 중...';

                // Start polling for status
                this.startPolling();

            } catch (error) {
                console.error('Excel generation request failed:', error);
                this.$vs.notify({
                    title: 'Error',
                    text: 'Excel 생성 요청 실패',
                    color: 'danger',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-x'
                });
                this.resetExcelState();
            }
        },

        /**
         * Poll job status every 2 seconds
         */
        startPolling() {
            let pollCount = 0;
            const maxPolls = 60; // 2 minutes maximum

            this.pollInterval = setInterval(async () => {
                pollCount++;

                if (pollCount > maxPolls) {
                    clearInterval(this.pollInterval);
                    this.$vs.notify({
                        title: 'Warning',
                        text: '생성 시간이 너무 오래 걸립니다. 잠시 후 다시 시도해주세요.',
                        color: 'warning',
                        position: 'top-right'
                    });
                    this.resetExcelState();
                    return;
                }

                try {
                    const { data } = await axiosClass.get(
                        `/api/cure/excel/status/${this.excelJobId}`,
                        {},
                        true
                    );

                    if (data.status === 'processing') {
                        this.excelProgress = 50;
                        this.excelStatusText = '데이터 처리 중...';
                        this.excelStatusMessage = `경과 시간: ${pollCount * 2}초`;

                    } else if (data.status === 'completed') {
                        this.excelProgress = 100;
                        this.excelStatusText = '완료!';
                        this.excelStatusMessage = 'Excel 파일 다운로드 준비 완료';
                        clearInterval(this.pollInterval);
                        this.downloadExcelFile();

                    } else if (data.status === 'failed') {
                        clearInterval(this.pollInterval);
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Excel 생성 실패: ' + (data.error || '알 수 없는 오류'),
                            color: 'danger',
                            position: 'top-right'
                        });
                        this.resetExcelState();
                    }

                } catch (error) {
                    console.error('Polling error:', error);
                }
            }, 2000); // Check every 2 seconds
        },

        /**
         * Download completed Excel file
         */
        downloadExcelFile() {
            window.location.href = `/api/cure/excel/download/${this.excelJobId}`;

            setTimeout(() => {
                this.$vs.notify({
                    title: 'Success',
                    text: 'Excel 파일 다운로드 완료',
                    color: 'success',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check'
                });
                this.resetExcelState();
            }, 1000);
        },

        /**
         * Cancel Excel generation
         */
        cancelExcelGeneration() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval);
            }
            this.resetExcelState();
        },

        /**
         * Reset Excel generation state
         */
        resetExcelState() {
            this.excelGenerating = false;
            this.showExcelProgress = false;
            this.excelProgress = 0;
            this.excelStatusText = '준비 중...';
            this.excelStatusMessage = '';
            this.excelJobId = null;
        },

        // ==================== 필터 검색 관련 메서드 ====================

        /**
         * 필터 모달 열기
         */
        openFilterModal() {
            this.filterModalVisible = true;
        },

        /**
         * 필터 모달 닫기
         */
        closeFilterModal() {
            this.filterModalVisible = false;
        },

        /**
         * 필터 적용
         */
        async handleFilterConfirm(criteria) {
            // 필터 모드 진입 시 아직 안 불러온 시간대가 있으면 전체 로드
            if (this.hasMoreTimeSlots) {
                const params = {
                    medical_cd: this.medical_cd,
                    uid: this.loginUid,
                    days: this.dayFilter,
                };
                const { data } = await axiosClass.get('/api/cure/listV2/' + this.now_date, params, true);
                this.cure_data = data.cure_data;
                this.hasMoreTimeSlots = false;
                this.scrollOffset = data.cure_data.length;
            }
            this.filterCriteria = { ...criteria };
            this.filteredSchedules = this.computeFilteredSchedules();
            this.filterMode = true;
            this.closeFilterModal();
        },

        /**
         * 클라이언트 사이드 필터링 로직
         */
        computeFilteredSchedules() {
            const { medicalCd, date, hour } = this.filterCriteria;

            const filtered = [];

            for (let timeBlock of this.cure_data) {
                const schedulesOnDate = timeBlock.schedules_by_day && timeBlock.schedules_by_day[date]
                    ? timeBlock.schedules_by_day[date]
                    : [];

                for (let schedule of schedulesOnDate) {
                    // Medical code filter (empty string means "전체" - show all)
                    if (medicalCd && schedule.MEDICAL_CODE !== medicalCd) continue;

                    // Time filter: If hour is 'ALL', skip time filtering
                    if (hour !== 'ALL') {
                        const hourStart = hour + '00';
                        const hourEnd = hour + '59';
                        const realTime = schedule.REAL_TIME_STRING;
                        if (!realTime || realTime < hourStart || realTime > hourEnd) continue;
                    }

                    filtered.push(schedule);
                }
            }

            // Sort by REAL_TIME_STRING ascending
            return filtered.sort((a, b) => a.REAL_TIME_STRING.localeCompare(b.REAL_TIME_STRING));
        },

        /**
         * 필터 리셋 (캘린더 모드로 복귀)
         */
        resetFilter() {
            this.filterMode = false;
            this.filterCriteria = {
                medicalCd: '',
                date: '',
                hour: ''
            };
            this.filteredSchedules = [];
        },

        /**
         * Medical Code로 치료실 이름 조회
         */
        getMedicalNameByCd(medicalCd) {
            if (!medicalCd) return '전체';
            const room = this.tab_menu.find(r => r.MEDICAL_CD === medicalCd);
            return room ? room.MEDICAL_NM : medicalCd;
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.loginUid = store.getters.getUID;
        document.title = this.$route.meta.title || '메디람한방병원';
        this.init('');
        this.$nextTick(() => {
            const inputElement = this.$refs.searchInput.$el.querySelector("input");
            if (inputElement) {
            inputElement.addEventListener("keyup", (event) => {
                if (event.key === "Enter") {
                    
                this.searchPatient(inputElement.value);
                }
            });
            }
        });
    },

    computed: {
        scrollLimit() {
            const availableHeight = this.windowHeight - 500;
            const rowHeight = 120; // 100px row + padding/border
            return Math.max(3, Math.floor(availableHeight / rowHeight));
        },
        nowDate() {
            return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월';
        },
        filterModeActive() {
            return this.filterMode &&
                   this.filterCriteria.date &&
                   this.filterCriteria.hour;
        },
    },
    beforeDestroy() {
        this.teardownScrollObserver();
        window.removeEventListener('resize', this.handleResize);

        // Clean up Excel polling interval
        if (this.pollInterval) {
            clearInterval(this.pollInterval);
        }
    },
};

window.addEventListener('resize', reportWindowSize);
window.addEventListener('load', reportWindowSize);
function reportWindowSize() {
    document.getElementById('calendarDiv').style.height = document.documentElement.clientHeight - 500 + 'px';
}
</script>

<style>
/* 연차 표시 스타일 - 2026-02-01 */
.vacation-text {
    color: #e74c3c;
}

.calendar tbody tr td {
    padding: 10px;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 0.9rem;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}
table > thead > tr > th {
    font-weight: 400;
    background-color: blue;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    z-index: 1;
}
table > tbody > tr > td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.tb_box {
    overflow: auto;
}
.table_header {
    position: sticky;
    top: 0;
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}
.contentTable {
    font-size: 12px;
}
.headerBtn {
    background-color: rgba(241, 241, 241, 0.9);
    padding: 5px 10px;
}
.headerBtn a {
    padding: 5px;
}

.timeHeader {
    position: sticky;
    left: 0;
    top: auto; /* table_header의 top:0 세로 sticky 무효화 - 시간 라벨 겹침 방지 (2026-07-02) */
    z-index: 999;
}

/* 다중 복사 팝업 스타일 */
.multi-copy-popup .con-vs-popup {
    max-width: 600px;
    min-height: 400px;
}

.multi-copy-container {
    padding: 20px;
}

.schedule-item {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.target-date-item {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.time-input {
    width: 100px;
    text-align: center;
}

.target-dates-container {
    max-height: 300px;
    overflow-y: auto;
}

/* 체크박스 다중 복사 모드 스타일 */
.time-slot-checkbox {
    width: 18px;
    height: 18px;
    margin: 2px;
    cursor: pointer;
}

.time-slot-checkbox:hover {
    transform: scale(1.1);
}

.bulk-copy-mode {
    background-color: #f0f8ff;
    border: 2px solid #28a745;
}

.bulk-copy-header {
    background-color: #e8f5e8;
    font-weight: bold;
}

/* .tb_box::-webkit-scrollbar {
  display: none;
} */

/* 필터 검색 관련 스타일 */
.filter-active-banner {
    background-color: #e8f5e9;
    border: 1px solid #81c784;
    border-radius: 6px;
    padding: 12px 16px;
}

.filter-info {
    font-weight: 500;
    color: #2e7d32;
}

.filter-active-banner i {
    color: #43a047;
    font-size: 1.1rem;
}
</style>
